<pos-app-spinner [show]="isLoadingCustomerVehicles$ | async"></pos-app-spinner>
<div class="card" *ngIf="{ values: customerVehicles$ | async } as customerVehicles">
  <div class="card-body">
    <div class="text-warning" *ngIf="!(isLoadingCustomerVehicles$ | async) && customerVehicles?.values?.length === 0">
      The customer currently has no vehicle. Please add a vehicle to this customer
    </div>
    <div *ngIf="customerVehicles?.values?.length > 0">
      <div class="custom-control custom-checkbox my-1 mr-sm-2 text-right">
        <input type="checkbox" class="custom-control-input m-2" id="customControlInline" [checked]="showRetired" (change)="showRetiredToggle()" />
        <label class="custom-control-label" for="customControlInline">Show Retired Vehicles</label>
      </div>
      <div class="text-warning" *ngIf="!(hasActiveVehicle$ | async) && !showRetired">
        This customer has no active vehicle. Check the 'Show Retired Vehicles' to see all retired vehicles
      </div>
      <table class="table table-sm table-bordered" *ngIf="(hasActiveVehicle$ | async) || showRetired">
        <thead>
          <tr>
            <th scope="col">Default</th>
            <th scope="col">Promotions</th>
            <th scope="col">Short Description</th>
            <th scope="col">Rego</th>
            <th scope="col">Colour</th>
            <th scope="col">Date Added</th>
            <th scope="col" *ngIf="showRetired">Date Retired</th>
            <th scope="col">Vehicle Long Description</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let vehicle of customerVehicles?.values; let i = index"
            (click)="selectVehicle(vehicle)"
            [ngClass]="(customerVehicles?.values)[i] === selectedVehicle ? 'table-primary' : ''"
            [hidden]="!showRetired && (customerVehicles?.values)[i].DateRetired !== ''"
          >
            <td class="text-center">
              <mat-icon *ngIf="vehicle.DefaultFlag === '1'">check</mat-icon>
            </td>
            <td class="text-center">
              <div *ngIf="vehicle.promoArray.length > 0">
                <div>
                  <div *ngFor="let promo of vehicle.promoArray">
                    <mat-icon tooltipClass="custom-tooltip" [matTooltip]="promo.promotionName + ' - ' + promo.promotionShortDescription" style="height: 40px;">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f">
                        <path
                          d="M260-320q25 0 42.5-17.5T320-380q0-25-17.5-42.5T260-440q-25 0-42.5 17.5T200-380q0 25 17.5 42.5T260-320Zm360 0q20 0 36-12t21-31q-20-4-38-13.5T606-401l-25-25q-10 8-15.5 20t-5.5 26q0 25 17.5 42.5T620-320Zm-460 40v-200 200Zm40 80v40q0 17-11.5 28.5T160-120h-40q-17 0-28.5-11.5T80-160v-320l84-240q6-18 21.5-29t34.5-11h140v55q0 6 .5 12.5T362-680H234l-42 120h255l80 80H160v200h560v-81q22-2 42.5-11t37.5-25v237q0 17-11.5 28.5T760-120h-40q-17 0-28.5-11.5T680-160v-40H200Zm400-520q17 0 28.5-11.5T640-760q0-17-11.5-28.5T600-800q-17 0-28.5 11.5T560-760q0 17 11.5 28.5T600-720Zm62 262L458-662q-8-8-13-19.5t-5-23.5v-155q0-25 17.5-42.5T500-920h155q12 0 23.5 5t19.5 13l204 204q17 17 17 42.5T902-613L747-458q-17 17-42.5 17T662-458Zm43-70 127-127-185-185H520v127l185 185Zm-29-156Z"
                        />
                      </svg>
                    </mat-icon>
                  </div>
                </div>
              </div>
            </td>

            <td>
              {{ vehicle.ShortDescription
              }}<span class="px-2"
                ><mat-icon
                  (click)="copyToClipBoard(vehicle.CustomerVehicleID, true)"
                  [matTooltip]="!vehicleCustomerIDCopied || copiedValue !== vehicle.CustomerVehicleID ? 'Copy Customer Vehicle ID' : 'Copied'"
                  >move_to_inbox</mat-icon
                ></span
              >
            </td>
            <td>{{ vehicle.RegoNumber }}</td>
            <td>{{ vehicle.ColourCode }}</td>
            <td>{{ vehicle.DateCreated }}</td>
            <td *ngIf="showRetired">{{ vehicle.DateRetired }}</td>
            <td>
              {{ vehicle.VehicleFullDescription
              }}<span class="px-2"
                ><mat-icon
                  (click)="copyToClipBoard(vehicle.VehicleID)"
                  [matTooltip]="!vehicleIDCopied || copiedValue !== vehicle.VehicleID ? 'Copy Generic Vehicle ID' : 'Copied'"
                  >move_to_inbox</mat-icon
                ></span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pt-2 pb-3">
      <button class="btn arb-other-button" [routerLink]="['/pos/customers/'] + selectedCustomerNumber + '/add/vehicles'">Add Vehicle</button>
      <span *ngIf="selectedVehicle">
        <span class="px-2"
          ><button
            class="arb-other-button"
            [routerLink]="['/pos/customers/'] + selectedCustomerNumber + '/vehicles/' + selectedVehicle.customerVehicleID"
          >
            Edit Vehicle
          </button></span
        >
        <span *ngIf="{ values: defaultVehicle$ | async } as defaultVehicle">
          <span
            class="pr-2"
            *ngIf="defaultVehicle?.values?.CustomerVehicleID !== selectedVehicle.customerVehicleID && selectedVehicle.DateRetired === ''"
          >
            <button class="arb-other-button px-2" (click)="makeDefault(defaultVehicle.values)">Make Vehicle Default</button>
          </span>
        </span>
        <button
          type="button"
          class="arb-other-button"
          placement="right"
          [ngbPopover]="retireCode"
          popoverTitle="Please select the retire code"
          [autoClose]="'outside'"
          #popOver="ngbPopover"
          *ngIf="selectedVehicle.DateRetired === ''"
        >
          Retire Vehicle
        </button>
        <button class="arb-other-button" *ngIf="selectedVehicle.DateRetired !== ''" (click)="unRetire()">Un-retire Vehicle</button>
      </span>
    </div>
  </div>
</div>

<ng-template #retireCode>
  <select [formControl]="retireCodeForm">
    <option *ngFor="let reason of (lookupLists$ | async).vehicleRetiredReasonList" [value]="reason.VehicleRetiredReasonCode">
      {{ reason.VehicleRetiredReasonCode + ' - ' + reason.VehicleRetiredReasonDescription }}
    </option>
  </select>
  <div class="pt-1">
    <button class="btn btn-success btn-sm" (click)="retire()">OK</button>
  </div>
</ng-template>
